(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairGoalsController', PhysicalFairGoalsController);
    PhysicalFairGoalsController.$inject = ['$uibModal', 'ExpoService', 'PhysicalFairService','toastr'];
    function PhysicalFairGoalsController($uibModal, ExpoService, PhysicalFairService, toastr) {
        var vm = this;
        vm.flag                  = false;
        vm.result                = [];
        vm.resultAux             = [];
        vm.previous_value        = [];
        //vm.goalResult            = [];
        vm.expoSelected          = [];
        vm.semesterSelected      = [];
        vm.semester              = [];
        //vm.sellerResult          = [];
        vm.i                     = -1;
        vm.selectExpo            = selectExpo;
        vm.getSemester           = getSemester;
        vm.selectExpoBySemester  = selectExpoBySemester;
        vm.getByFilter           = getByFilter;
        vm.citySelected          = [];
        vm.saveGoal              = saveGoal;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        function activate() {
            vm.selectExpo();
            vm.getSemester();
        }

        function getSemester () {
            ExpoService.getSemester().then(function(response){
                 vm.semester = response.data;
            }).catch(function(err) {
            });
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                vm.expo = response.data;
            }).catch(function(err) {
            });
        }

        function selectExpoBySemester () {
            var query = [];
            query['semester'] = vm.semesterSelected.semester;
            ExpoService.getExpoBySemester(query).then(function(response){
                vm.expo = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            if(typeof vm.semesterSelected !== 'undefined') {
                vm.query['semester'] = vm.semesterSelected.semester;
            }
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            vm.query['goal_type'] = 'goal';
            /* Load variables to CSV */
           var serviceSearch = PhysicalFairService.getByFilterGoals(vm.query);
           return  serviceSearch.then(function(response){
               vm.result.goals = response.data;
               vm.resultAux.goals = response.data;
               return PhysicalFairService.getExpos(vm.query);
            }).then(function(response){
               vm.result.expos = response.data;
               if(vm.result.goals.length == 0) {
                   vm.noResultMessage = 'Sorry, no results were found!';
                   vm.flag = false;
               } else {
                   vm.noResultMessage = '';
                   vm.flag = true;
               }
            }).catch(function(err){
            });
        }

        function saveGoal(expo_id, seller_id, goal_money, seller, oldGoal) {
           var parameter =  [];
            if(typeof expo_id !== 'undefined') {
                parameter['expo_id'] = expo_id;
                if(typeof seller_id !== 'undefined') {
                    parameter['seller_id'] = seller_id;
                    if(typeof goal_money !== 'undefined') {
                        parameter['goal_money'] = goal_money;

                        if(typeof vm.query['expo_id'] !== 'undefined') {
                            parameter['filter_expo_id'] = vm.query['expo_id'];
                        }
                        if(typeof vm.query['semester'] !== 'undefined') {
                            parameter['filter_semester'] = vm.query['semester'];
                        }
                        PhysicalFairService.saveGoal(parameter).then(function(response) {
                            if(typeof response.data !== 'undefined') {
                                // Remove the previous total
                                vm.result.goals[2] = parseFloat(vm.result.goals[2]) - parseFloat(vm.resultAux.goals[0][seller_id].total_goal_by_seller);
                                vm.resultAux.goals[0][seller_id].total_goal_by_seller = vm.result.goals[0][seller_id].total_goal_by_seller;
                                seller.total_goal_by_seller = parseFloat(response.data.total_seller);
                                console.log(vm.result.goals[2]);

                                vm.result.goals[2] = parseFloat(vm.result.goals[2]) + parseFloat(response.data.total_seller);
                                vm.result.goals[1][expo_id].total_goal_by_expo = parseFloat(response.data.total_expo);
                                toastr.success('Successfully edited!');
                            } else {
                                toastr.error('Try again later!', 'Error');
                            }
                        }).catch(function(err) {
                            toastr.danger('Error: '+err);
                        });
                    }
                }
            }
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        activate();
    }
})();